module.exports = __webpack_public_path__ + "static/media/clickableQuestions.056dcca1.webm";